<template>
  <div>
    <div class="boomsales">
      <div class="boomsalesS">
        <div class="boomsalesSl">
          <img src="../assets/Palm Cube-Logo-09.png" alt="">
          <p>BoomSales is a tool designed to facilitate <br>
            company-wide affiliate sales, making it <br>
            possible to implement and manage affiliate <br>
            sales strategies across all members of an <br>
            organization.</p>
          <p>It provides the necessary features and <br>
            functionality to enable and track affiliate sales <br>
            activities.</p>
          <p>With BoomSales, organizations can harness <br>
            the power of their entire workforce to drive <br>
            affiliate sales and expand their sales reach.</p>
          <button class="demo" @click="demo">Request a demo</button>
        </div>
        <div class="boomsalesSr">
          <img src="../assets/boom7.png" alt="">
        </div>
      </div>
      <div class="aboutD">
        <div class="aboutD-z">
          <div class="left">
            <img src="../assets/Palm Cube-Logo-06.png" alt="">
            <span class="us">Contact US</span>
            <p>+234 9064837926</p>
            <p>lockettqin@palm-cube.com</p>

            <span>SHANGHAI</span>
            <p>Lumous intelligent Technology <br>(shanghia)Co,Ltd</p>

            <span class="lagos">LAGOS</span>
            <p>Address: ATG House, 2A, Isaac John Street,<br>GRA Ikeja, Lagos, Nigeria.</p>
          </div>
          <div class="right">
            <div>
              <input v-model="fullName" type="text" class="input" style="width: 600px; height: 40px;"
                placeholder="Name(*)">
            </div>
            <div>
              <input v-model="mobile" type="text" class="input" style="width: 600px; height: 40px;"
                placeholder="Mobile(*)">
            </div>
            <div>
              <input v-model="email" type="text" class="input" style="width: 600px; height: 40px; "
                placeholder="Email(*)">
            </div>
            <div>
              <textarea type="text" v-model="message" class="input" style="width: 600px; height: 120px; "
                placeholder="Leave your message..." />
            </div>
            <div>
              <button class="sand" @click="addClick" style="width: 100px;height: 30px;">Send</button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="boomsalesPhone">
      <Float></Float>
      <div class="designed">
        <img src="../assets/Palm Cube-Logo-09.png" alt="">
        <div class="tool">
          <p>BoomSales is a tool designed to facilitate
            company-wide affiliate sales, <br> making it
            possible to implement and manage affiliate
            sales  strategies <br> across all members of an
            organization.</p>
          <p>It provides the necessary features and
            functionality to enable and track af- <br> filiate sales
            activities.</p>
          <p>With BoomSales, organizations can harness
            the power of their entire work- <br> force to drive
            affiliate sales and expand their sales reach.</p>
        </div>
        <button class="demo" @click="demo">Request a demo</button>
      </div>
      <div class="boomsalesPhonetup">
        <img src="../assets/boom7.png" alt="">
      </div>
      <div class="aboutPhoneUs">
        <div>
          <img src="../assets/Palm Cube-Logo-06.png" alt="">
          <p class="Contact1">Contact US </p>
          <p>+234 9064837926 <br>lockettqin@palm-cube.com</p>
          <p class="Contact2">SHANGHAI </p>
          <p>Lumous intelligent Technology (shanghai)Co,Ltd</p>
          <p class="Contact2">LAGOS </p>
          <p>Address: ATG House, 2A, Isaac John Street,<br>GRA Ikeja, Lagos, Nigeria.</p>
        </div>
        <div class="aboutPhoneUsright">
          <div>
              <input v-model="fullName" type="text" class="input" style="width: 300px; height: 30px;"
                placeholder="Name(*)">
            </div>
            <div>
              <input v-model="mobile" type="text" class="input" style="width: 300px; height: 30px;"
                placeholder="Mobile(*)">
            </div>
            <div>
              <input v-model="email" type="text" class="input" style="width: 300px; height: 30px; "
                placeholder="Email(*)">
            </div>
            <div>
              <textarea type="text" v-model="message" class="input" style="width: 300px; height: 80px; "
                placeholder="Leave your message..." />
            </div>
            <div>
              <button class="sand" @click="addClick" style="width: 80px;height: 30px;">Send</button>
            </div>


        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import  Float  from "../components/Float";
export default {
  components:{
    Float
  },
  data() {
    return {
      input: '',
      textarea: '',
      fullName: '',
      mobile: '',
      email: '',
      message: '',
    }
  },
  methods: {
    demo() {
      this.$router.push('/about');
    },
    addClick() {
      // axios.post('http://192.168.31.101:31200/customer/contact/add',{}).then(res => {
      axios.post('http://unicorn-uiserver-server.palm-cube.com/customer/contact/add ', {
        fullName: this.fullName, mobile: this.mobile, email: this.email, message: this.message
      }).then(res => {
        this.fullName = '',
          this.mobile = '',
          this.email = '',
          this.message = ''
          if (res.data.errCode==0) {
          this.$router.push('/thanks');

          //   this.$notify({
          //   title: 'success',
          //   type: 'success'
          // });
            
          }
        // this.$message.success('添加成功！')
        console.log(res)
      }).catch(error => {
        console.log(error)
      })
    }
  },
  
}
</script>

<style lang="scss">
.boomsalesPhone {
  display: none;

  .designed {
    text-align: center;
    img {
      text-align: left;
      display: block;
      margin-top: 100px;
      width: 200px;
    }
    .tool{
      text-align: left;
      width: 80%;
      margin: auto;
      font-size: 15px;
    }
  }


 

  .demo {
    font-size: 26px;
    margin-top: 10px;
    width: 260px;
    height: 60px;
    background-color: #32c89b;
    text-align: center;
    color: #fff;
    border-radius: 30px;
    border: none;
  }

  .boomsalesPhonetup {
    margin-top: 80px;
    text-align: center;
    margin-bottom: 80px;

    img {
      width: 500px;
    }
  }

  .aboutPhoneUs {
    background-color: #F2F2F2;

    >div:nth-child(1) {
      text-align: left;

      img {
        width: 200px;
        // font-size: 40px;
      }

      .Contact1 {
        font-size: 40px;
        font-weight: 600;
        color: #444198;
      }

      .Contact2 {
        font-size: 40px;
        font-weight: 600;
        // color: #444198;
      }

      p {
        font-size: 20px;

      }
    }
  }

  .aboutPhoneUsright {
    height: 600px;
    margin-top: 20px;

    >div:nth-child(1) {
      margin: 10px 0;
    }

    >div:nth-child(2) {
      margin: 10px 0;
    }

    >div:nth-child(3) {
      margin: 10px 0;
    }

    >div:nth-child(4) {
      margin: 10px 0;
    }

    >div:nth-child(5) {
      margin: 5px 0;

      .sand {
        text-align: center;
        background-color: #444198;
        color: #fff;
        border-radius: 20px;
        border: none;
      }
    }
  }
}





.boomsales {
  display: block;
}

.boomsalesS {
  margin-top: 40px;
  padding: 50px 40px;
  // background-color: aqua;
  display: flex;
  justify-content: space-evenly;
}

.boomsalesSl {
  img {
    width: 100px;
  }

  p {
    font-size: 10px;
  }

  .demo {
    margin-top: 10px;
    width: 60px;
    height: 15px;
    background-color: #32c89b;
    text-align: center;
    color: #fff;
    border-radius: 20px;
    border: none;
  }
}

.boomsalesSr {
  img {
    width: 200px;
  }
}

.boomsalesX {
  background-color: #F2F2F2;
  width: 100%;
  height: 200px;


  .aboutD-z {
    padding: 20px 100px;
    display: flex;
    justify-content: space-evenly;
    // justify-content: center;
    // align-items: center;
  }


  // color:	#F5F5F5;
  .left {
    // width: 60%;
    text-align: left;

    img {
      width: 60px;
    }

    .us {
      display: block;
      color: #444198;
      font-size: 16px;
      font-weight: 600;
    }

    p {
      color: #000;
    }

    span {
      font-size: 18px;
      font-weight: 600;

    }

    .lagos {
      font-size: 18px;
      font-weight: 600;
    }
  }

  .right {
    margin-top: 20px;

    >div:nth-child(1) {
      margin: 10px 0;
    }

    >div:nth-child(2) {
      margin: 10px 0;
    }

    >div:nth-child(3) {
      margin: 10px 0;
    }

    >div:nth-child(5) {
      margin: 5px 0;

      .sand {
        text-align: center;
        background-color: #444198;
        color: #fff;
        border-radius: 20px;
        border: none;
      }
    }
  }
}

@media(max-width: 1200px) {
  .boomsales {
    display: none;
  }
}

@media(max-width: 1200px) {
  .boomsalesPhone {
    display: block;
  }
}</style>